/**
 * ttm-squeeze-page.js
 *
 * TTM Squeeze strategy (John Carter) — across Weekly, Daily, 4H:
 *   Bollinger Bands(20,2) compress fully inside Keltner Channels(20,2) —
 *   that's the squeeze. Alert fires the bar the squeeze releases (bands
 *   expand back outside the Keltner channel); direction comes from the
 *   momentum oscillator's sign at that fire bar.
 *   Long:  squeeze fires with positive momentum
 *   Short: squeeze fires with negative momentum
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTtmSqueezeData } from '../services/server-api';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const momVal = entry.sqzMom != null ? entry.sqzMom.toFixed(4) : '—';
  return (
    <div className="mtf-ind-row">
      <span className="mtf-ind-label">Momentum</span>
      <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
        {momVal} {entry.state === 'long' ? '(bullish fire)' : '(bearish fire)'}
      </span>
    </div>
  );
}

function TtmSqueezePage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'TTM Squeeze',
        icon:       '🧨',
        subtitle:   'Bollinger(20,2) inside Keltner(20,2) fires on release · direction from the momentum oscillator',
        fetchFn:    fetchTtmSqueezeData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TtmSqueezePage;
